import React, { useState } from 'react';
import { CourseSidebar } from './CourseSidebar';
import { CourseProgressProvider } from '../../lib/course-progress-context';
import { cn } from '../../lib/utils';
import EditorHalf from '../EditorHalf';

export const CourseLayoutEditor = ({ 
  children, 
  className, 
  courseStructure, 
  courseId,
  initialCode,
  userId,
  projectId,
  workdir,
  showAssets = false,
  onCodeChange,
  isPurchased = true
}) => {
  // État pour suivre l'onglet actif sur mobile (0 = Cours, 1 = Code)
  const [activeTab, setActiveTab] = useState(0);

  // Fonction pour gérer les modifications de code
  const handleCodeChange = (newCode) => {
    if (onCodeChange) {
      onCodeChange(newCode);
    }
  };

  return (
    <CourseProgressProvider>
      <div className="flex flex-col md:flex-row">
        {/* Sidebar à gauche - Fixe */}
        <CourseSidebar courseStructure={courseStructure} courseId={courseId} isPurchased={isPurchased} />
        
        {/* Navigation par onglets - Visible uniquement sur mobile */}
        <div className="md:hidden fixed top-16 left-0 right-0 z-10 px-4 py-2 bg-background/95 backdrop-blur-sm border-b border-border/40 shadow-sm">
          <div className="flex rounded-full bg-neutral-100 dark:bg-gray-800 p-1 w-full max-w-md mx-auto">
            <button
              onClick={() => setActiveTab(0)}
              className={`flex-1 rounded-full py-2 px-3 text-center text-sm font-medium ${
                activeTab === 0
                  ? 'bg-indigo-500 text-white shadow'
                  : 'text-neutral-600 dark:text-gray-300 hover:bg-neutral-300 dark:hover:bg-gray-700 hover:text-neutral-900 dark:hover:text-white'
              }`}
            >
              Cours
            </button>
            <button
              onClick={() => setActiveTab(1)}
              className={`flex-1 rounded-full py-2 px-3 text-center text-sm font-medium ${
                activeTab === 1
                  ? 'bg-indigo-500 text-white shadow'
                  : 'text-neutral-600 dark:text-gray-300 hover:bg-neutral-300 dark:hover:bg-gray-700 hover:text-neutral-900 dark:hover:text-white'
              }`}
            >
              Code
            </button>
          </div>
        </div>
        
        {/* Contenu du cours au milieu - Défilant - VISIBLE SUR DESKTOP */}
        <div className="hidden md:block md:ml-[240px] p-4 md:p-6 md:pr-[42%] w-full overflow-y-auto transition-all">
          <div className={cn("container mx-auto px-4 w-full", className)}>
            {children}
          </div>
        </div>
        
        {/* Éditeur à droite - Fixe - VISIBLE SUR DESKTOP */}
        <div className="hidden md:block fixed right-[2rem] top-[6rem] w-[38%] h-[calc(100vh-8rem)] bg-background rounded-lg shadow-lg border border-border/30">
          <EditorHalf 
            initialCode={initialCode} 
            workdir={workdir}
            userId={userId || "exercise"}
            projectId={projectId || "temp"}
            showPlay={true}
            showAssets={showAssets}
            allowRun={true}
            defaultView="code"
            onCodeChange={handleCodeChange}
          />
        </div>
        
        {/* Version mobile - Affiche soit le cours, soit le code en fonction de l'onglet actif */}
        <div className="md:hidden w-full mt-16">
          {/* Onglet Cours */}
          {activeTab === 0 && (
            <div className="p-4 pb-24 overflow-y-auto">
              <div className={cn("w-full", className)}>
                {children}
              </div>
            </div>
          )}
          
          {/* Onglet Code */}
          {activeTab === 1 && (
            <div className="absolute top-[5rem] left-4 right-4 bottom-[1rem] bg-background rounded-lg shadow-lg border border-border/30 overflow-hidden">
              <div className="w-full h-full">
                <EditorHalf 
                  initialCode={initialCode} 
                  workdir={workdir}
                  userId={userId || "exercise"}
                  projectId={projectId || "temp"}
                  showPlay={true}
                  showAssets={showAssets}
                  allowRun={true}
                  defaultView="code"
                  onCodeChange={handleCodeChange}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </CourseProgressProvider>
  );
}; 